import { ReactNode } from 'react';
import { useApiInterceptor } from './useApiInterceptor';

interface ApiInterceptorProviderProps {
  children: ReactNode;
}

export function ApiInterceptorProvider({ children }: ApiInterceptorProviderProps) {
  useApiInterceptor();

  return <>{children}</>;
}
